<template>
  <svg
    v-tooltip="{ hideTooltip: hideTooltip, text: tooltip }"
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
  >
    <g clip-path="url(#clip0_4830_10895)">
      <path
        d="M11.3156 0H4.68444L0 4.68444V11.3156L4.68444 16H11.3156L16 11.3156V4.68444L11.3156 0Z"
        :fill="getColorByPriority"
        fill-opacity="0.3"
      />
      <path
        d="M6.84375 11.5547C6.84375 12.1947 7.35931 12.7102 7.99931 12.7102C8.63931 12.7102 9.15486 12.1947 9.15486 11.5547C9.15486 10.9147 8.63931 10.3991 7.99931 10.3991C7.35931 10.3991 6.84375 10.9147 6.84375 11.5547Z"
        :fill="getColorByPriority"
      />
      <path
        d="M7.11042 8.88802H8.8882V3.55469H7.11042V8.88802Z"
        :fill="getColorByPriority"
      />
    </g>
    <defs>
      <clipPath id="clip0_4830_10895">
        <rect width="16" height="16" fill="white" />
      </clipPath>
    </defs>
  </svg>
</template>

<script setup lang="ts">
  import { computed } from 'vue';
  interface Props {
    score: number | null;
    hideTooltip?: boolean;
  }

  const props = withDefaults(defineProps<Props>(), {
    hideTooltip: false
  });

  const getColorByPriority = computed(() => {
    if (props.score === null) return '#AABDD7';

    return props.score >= 3
      ? '#ED645E'
      : props.score === 2
        ? '#FFCE2A'
        : '#AABDD7';
  });

  const tooltip = computed(() => {
    if (props.score === null) return 'Low patch priority, patch within 30 days';

    return props.score >= 3
      ? 'High patch priority, patch immediately'
      : props.score === 2
        ? 'Medium patch priority, patch within 7 days'
        : 'Low patch priority, patch within 30 days';
  });
</script>
